export default __webpack_public_path__ + "static/media/xmas-slide3-mobile.ca98e999.jpg";